import React, { PureComponent } from 'react';
import { Trans } from 'react-i18next';
import Modal from '@jg/modal';
import Loading from '@jg/loading';
import config from '../../config';

type Props = {
  deleteTeam: () => void;
  onCloseModal: () => void;
  isModalOpen: boolean;
  isInFlight?: boolean;
};

class DeleteTeamModal extends PureComponent<Props> {
  handleClick = async () => {
    const { deleteTeam, onCloseModal } = this.props;
    await deleteTeam();
    onCloseModal();
  };

  render() {
    const { onCloseModal, isModalOpen, isInFlight } = this.props;
    return (
      <Modal
        classNames="jg-space-phmd@lg jg-tc-delete-team-modal-container"
        isOpen={isModalOpen}
        onRequestClose={onCloseModal}
      >
        <div className="jg-text--center">
          <img
            className="jg-space-mvmd"
            src={`${config.publicPath}public/robot-are-you-sure.svg`}
            alt="JustGiving robot"
            width="130"
            height="123"
          />
          <h1
            className="jg-space-mbms container--heading"
            data-qa="delete-team-modal"
          >
            <Trans i18nKey="content.deleteTeamModal.heading" />
          </h1>
          <p className="jg-text--large">
            <Trans i18nKey="content.deleteTeamModal.paragraphone">
              If you delete your team page, it will no longer be visible on
              JustGiving. <strong>This cannot be undone.</strong>
            </Trans>
          </p>
          <p className="jg-text--large jg-space-mtms jg-space-mbmd jg-space-mbxl@lg">
            <Trans i18nKey="content.deleteTeamModal.paragraphtwo" />
          </p>
        </div>

        <div className="jg-tc-button-container">
          <button
            type="button"
            data-qa="delete-team"
            disabled={isInFlight}
            onClick={this.handleClick}
            className="jg-btn jg-space-mbms"
          >
            {isInFlight ? (
              <Loading size="small" colour="white" />
            ) : (
              <Trans i18nKey="content.deleteTeamModal.yes" />
            )}
          </button>

          <button
            type="button"
            data-qa="cancel"
            onClick={onCloseModal}
            className="jg-btn jg-btn--ghost"
          >
            <Trans i18nKey="content.deleteTeamModal.no" />
          </button>
        </div>
      </Modal>
    );
  }
}

export default DeleteTeamModal;
